import { useMe } from '../hooks/useMe';

interface Props {
  teamId: string;
}

export function ScopeDot({ teamId }: Props) {
  const { me } = useMe();
  const group = me?.groups.find((g) => g.id === teamId);
  const color = group?.color ?? '#94a3b8';
  const label = group?.displayName ?? 'Unknown group';
  return (
    <span
      className="scope-dot"
      style={{ backgroundColor: color }}
      title={label}
      aria-label={label}
    />
  );
}
